import { DialogCommonComponent } from '@qsp-ui-library/components/modal/shared/components/dialog-common/dialog-common.component';
import { DialogHeaderModule } from '@qsp-ui-library/components/modal/shared/components/dialog-header/dialog-header.module';
import { NgModule } from '@angular/core';

@NgModule({
  declarations: [DialogCommonComponent],
  exports: [DialogCommonComponent],
  imports: [DialogHeaderModule],
})
export class DialogCommonModule {}
